import { db } from "../../../../mp-database"
import parseSnapshot from "../../parseSnapshot"

/**
 * Fetches all activities related to userAssessment
 * from the activities collection in db
 * @param {object} userAssessment data on student interaction with assessment
 * @returns {object} fulfilled promise gives object with activities grouped by subtest
 */
export default function getActivity(userAssessment) {
  function groupBySubtest(activities) {
    let activityObj = {}
    const keys = Object.keys(activities)
    keys.forEach(key => {
      let activity = activities[key]
      const { subTestId } = activity
      if (!activityObj[subTestId]) {
        activityObj[subTestId] = {}
      }
      activityObj[subTestId][key] = activity
    })
    return activityObj
  }

  const id = userAssessment.userAssessmentId
  return db
    .collection("activities")
    .where("userAssessmentId", "==", id)
    .get()
    .then(querySnapshot => {
      const activities = parseSnapshot(querySnapshot)
      const groupedActivities = groupBySubtest(activities)
      return groupedActivities
    })
}
